import React, { forwardRef } from "react";

const PrescriptionPrint = forwardRef(({ data }, ref) => {
  return (
    <div
      ref={ref}
      style={{
        width: "210mm",
        height: "285mm",
        fontFamily: "Arial, sans-serif",
        fontSize: "12px",
        position: "relative",
        backgroundColor: "#ffffff",
        boxSizing: "border-box",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        padding: "20px",
      }}
    >
      {/* Watermark */}
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 0,
          opacity: 0.05,
          pointerEvents: "none",
        }}
      >
        <img
          src={`${process.env.REACT_APP_MEDIA_URL}/images/logo/logo.png`}
          alt="Watermark"
          style={{
            width: "150mm",
            height: "auto",
          }}
        />
      </div>

      {/* Content Container */}
      <div style={{ position: "relative", zIndex: 1, flex: "1 0 auto" }}>
        {/* Header Section */}
        <header
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            paddingBottom: "10px",
            marginBottom: "15px",
            direction: "ltr",
          }}
        >
          {/* Left Section */}
          <div style={{ textAlign: "left" }}>
            <h1
              style={{
                fontSize: "24px",
                fontWeight: "bold",
                margin: 0,
                color: "#000",
              }}
            >
              Afghan Turk International Clinic
            </h1>
            <p
              style={{
                fontSize: "14px",
                margin: "5px 0",
                color: "#E91E63",
                fontWeight: "600",
              }}
            >
              GAIN YOUR BEAUTY
            </p>
          </div>

          {/* Center Logo */}
          <div style={{ textAlign: "center" }}>
            <img
              src={`${process.env.REACT_APP_MEDIA_URL}/images/logo/logo.png`}
              alt="Clinic Logo"
              style={{ width: "80px", height: "auto", marginBottom: "5px" }}
            />
          </div>

          {/* Right Section */}
          <div style={{ textAlign: "right", direction: "rtl" }}>
            <h2
              style={{
                fontSize: "24px",
                fontWeight: "bold",
                margin: 0,
                color: "#E91E63",
              }}
            >
              افغان ترک بین المللی کلینیک
            </h2>
            <p
              style={{
                fontSize: "14px",
                margin: "5px 0",
                color: "#333",
              }}
            >
              زیبایی خود را به دست آورید
            </p>
          </div>
        </header>

        {/* Doctor Details Section */}
        <section
          style={{
            marginBottom: "10px",
            fontSize: "14px",
            direction: "rtl",
            borderBottom: "1px solid #E91E63",
            paddingBottom: "5px",
          }}
        >
          <p style={{ margin: "0", fontWeight: "bold" }}>
            <strong>داکتر:</strong> {data.doctor_display}
          </p>
        </section>

        {/* Patient Details Section */}
        <section
          style={{
            borderBottom: "2px solid #E91E63",
            padding: "10px 0",
            marginBottom: "20px",
            direction: "rtl",
          }}
        >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <p style={{ margin: "0", fontSize: "14px", width: "30%" }}>
              <strong>اسم مریض:</strong> {data.patient_display}
            </p>
            <p style={{ margin: "0", fontSize: "14px", width: "10%" }}>
              <strong>سن:</strong> {data.patient_age_display}
            </p>
            <p style={{ margin: "0", fontSize: "14px", width: "10%" }}>
              <strong>جنس:</strong> {data.patient_gender_display}
            </p>
            <p style={{ margin: "0", fontSize: "14px", width: "20%" }}>
              <strong>تاریخ:</strong> {data.date}
            </p>
          </div>
        </section>

        {/* Clinical Record Section */}
        <section
          style={{
            marginTop: "5px",
            display: "flex",
            flexDirection: "row",
            gap: 10,
          }}
        >
          <div
            style={{
              width: "20%",
              borderRight: "1px solid #E91E63",
              height: "180mm",
            }}
          >
            <p
              style={{
                fontSize: "14px",
                fontWeight: "bold",
                color: "#000",
              }}
            >
              Clinical Record:
            </p>
          </div>
          <div style={{ width: "80%", padding: "10px" }}>
            <p
              style={{
                fontSize: "14px",
                fontWeight: "bold",
                color: "#E91E63",
                marginBottom: "10px",
              }}
            >
              RX
            </p>

            {/* Medicines Section */}
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                marginTop: "10px",
                fontSize: "10px", // Smaller font for medicines
              }}
            >
              <thead>
                <tr
                  style={{
                    backgroundColor: "#f5f5f5",
                    borderBottom: "1px solid #E91E63",
                  }}
                >
                  <th style={{ padding: "6px", textAlign: "left" }}>#</th>
                  <th style={{ padding: "6px", textAlign: "left" }}>
                    Medicine
                  </th>
                  <th style={{ padding: "6px", textAlign: "left" }}>
                    Category
                  </th>
                  <th style={{ padding: "6px", textAlign: "left" }}>Dosage</th>
                  <th style={{ padding: "6px", textAlign: "left" }}>
                    Quantity
                  </th>
                  <th style={{ padding: "6px", textAlign: "left" }}>
                    Units/Meal
                  </th>
                  <th style={{ padding: "6px", textAlign: "left" }}>
                    Instructions
                  </th>
                </tr>
              </thead>
              <tbody>
                {data.drugs.map((drug, index) => (
                  <tr
                    key={index}
                    style={{
                      borderBottom: "1px solid #ddd",
                    }}
                  >
                    <td style={{ padding: "6px" }}>{index + 1}</td>
                    <td style={{ padding: "6px" }}>
                      {drug.stock_medicine_display}
                    </td>
                    <td style={{ padding: "6px" }}>
                      {drug.stock_medicine_category_display}
                    </td>
                    <td style={{ padding: "6px" }}>{drug.dosage}</td>
                    <td style={{ padding: "6px" }}>{drug.quantity}</td>
                    <td style={{ padding: "6px" }}>{drug.units_per_meal}</td>
                    <td style={{ padding: "6px" }}>{drug.is_before}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>
      </div>

      {/* Footer Section */}
      <footer
        style={{
          flexShrink: 0,
          width: "100%",
        }}
      >
        {/* Address Section */}
        <div
          style={{
            backgroundColor: "#000",
            color: "#fff",
            padding: "10px",
            fontWeight: "bold",
            fontSize: "12px",
          }}
        >
          چهار راهی سلیم کاروان٬ مقابل بلاک های ګلستان٬ کلینیک بین المللی افغان ترک
        </div>

        {/* Contact Information Section */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            backgroundColor: "#fff",
            padding: "15px 20px",
            borderTop: "3px solid #000",
          }}
        >
          {/* Left Column (Phone Numbers) */}
          <div style={{ textAlign: "left" }}>
            <p style={{ margin: "0", fontSize: "12px" }}>
              📞 +93 (0) 780 662 491
            </p>
            <p style={{ margin: "0", fontSize: "12px" }}>
              {/* 📞 +93 (0) 789 20 90 54 */}
            </p>
          </div>

          {/* Center Column (Email and Website) */}
          <div style={{ textAlign: "center" }}>
            <p style={{ margin: "0", fontSize: "12px" }}>
              📧 info@afghanturkinternationalclinic.com
            </p>
            <p style={{ margin: "0", fontSize: "12px" }}>
              {/* 🌐 https://afghanturkinternationalclinic.com */}
            </p>
          </div>

          {/* Right Column (WhatsApp Numbers) */}
          <div style={{ textAlign: "right" }}>
            <p style={{ margin: "0", fontSize: "12px" }}>
              📱 +93 (0) 793 176 562
            </p>
            <p style={{ margin: "0", fontSize: "12px" }}>
              {/* 📱 +93 (0) 789 20 90 54 */}
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
});

export default PrescriptionPrint;
